import styled from 'styled-components'

export const SquigglyArrowWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    font-weight: lighter;
    color: black;
`
